
import { BusinessUnitEmailContactEntityDecoratorBase } from './business-unit-email-contact.decorator.base';


export class BusinessUnitEmailContactEntityDecorator extends BusinessUnitEmailContactEntityDecoratorBase {
  constructor() {
    super();
  }
}



